import BaseEntity from './BaseEntity';
import PullRequestsMetric from './PullRequestMetric';
export default class PullRequestsMetricList extends BaseEntity {
    constructor(pullRequestsMetric) {
        super();
        this.pullRequestsMetrics = [];
        if (pullRequestsMetric.length) {
            this.pullRequestsMetrics = pullRequestsMetric.map((pullRequestMetric) => {
                let dailyData = [];
                if ('daily' in pullRequestMetric) {
                    dailyData = this.parseProperty(pullRequestMetric, 'daily');
                }
                return new PullRequestsMetric(this.parseProperty(pullRequestMetric, 'sprint'), dailyData);
            });
        }
    }
}
